export default __webpack_public_path__ + "static/media/enjoy-hunt.191969de.png";